/**
 * Generated bundle index. Do not edit.
 */

export * from './highlight-public-api';
